module.exports = __webpack_public_path__ + "img/wrench-simple.1f27118b.svg";